import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import ViewablePasswordField from 'components/ViewablePasswordField';
import './DeleteAccountForm.css';

const DeleteAccountForm = ({
  handleSubmit,
  closeModal,
  submitting,
  errorMessage
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [input, setInput] = useState('');

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  return (
    <form onSubmit={handleSubmit} className="delete-account-form">
      <h1 className="form-title" aria-level="1">
        DELETE ACCOUNT
      </h1>
      <div className="form-subtitle">
        Are you sure you want to permanently delete your online Wind Creek
        account?
        <br />
        <br />
        Your online details, balances, history, and rewards will be deleted and
        cannot be undone. This action will also disassociate your online account
        from all Wind Creek casino and partner accounts.
      </div>
      <Field
        label="Enter your password to continue"
        type="password"
        name="password"
        placeholder="Password"
        component={ViewablePasswordField}
        toggleVisibility={togglePasswordVisibility}
        showPassword={showPassword}
        disableOnSubmitting={true}
        onChange={e => setInput(e.target.value)}
      />
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      <div className="buttons-container">
        <button
          className="button-color-orange cancel-btn"
          disabled={submitting}
          type="button"
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          className="button-color-green delete-btn"
          disabled={submitting || !input}
          type="submit"
        >
          Delete
        </button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'deleteAccountForm'
})(DeleteAccountForm);
